export default "__VITE_ASSET__DUoM_6Y2__"